import { IconButton, Tooltip } from "@mui/material";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

export default function IconButtonUsers({...props}) {
    return (
        <Tooltip title="Users">
            <IconButton {...props}>
                <PeopleOutlineIcon sx={{ color: "#2c4992" }} size="small" ></PeopleOutlineIcon>
            </IconButton>
        </Tooltip>
    )
}